/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./index.scss";

import { duration } from "utils";
// animations
import { Zoom, Fade } from "react-reveal";

// images
import PointImage from "../../../assets/icons/point.svg";
// import Logo1 from "../../../assets/icons/com-logo1.svg";
// import Logo2 from "../../../assets/icons/com-logo2.svg";
// import Logo3 from "../../../assets/images/com-logo3.png";
// import Logo4 from "../../../assets/images/com-logo4.png";
// import Logo5 from "../../../assets/images/com-logo5.png";

const ProjectRoadmap = (props) => {
  return (
    <div ref={props.roadMapRef} className="project">
      <div className="projectContent">
        <div className="content">
          <Zoom bottom duration={duration}>
            <div className="viewImage">
              <img src={PointImage} alt="" />
            </div>
          </Zoom>

          <Fade bottom duration={duration}>
            <h1>Project Roadmap</h1>
          </Fade>

          <div className="viewTimeline">
            <Fade bottom duration={duration}>
              <div className="box july">
                <h3>Aug</h3>
                <p>
                  Private round 1 <br /> Private round 2 <br />
                  Twitter and medium growth
                  <br /> Program Telegram Community
                  <br /> Development Supporting
                  <br />
                  Influencer promotion
                </p>
              </div>
            </Fade>

            <Fade bottom duration={duration}>
              <div className="box aug">
                <h3>Sept</h3>
                <p>
                  Mainstream media and PR Token <br />
                  Minting event Wallet allocations <br />
                  Token locks Automated
                  <br />
                  Vesting smart contract
                  {/* <a href="#">View More</a> */}
                </p>
              </div>
            </Fade>

            <Fade bottom duration={duration}>
              <div className="box sep">
                <h3>Oct</h3>
                <p>
                  Deploy simulation proofs
                  <br />
                  Precog stage 1 Public beta <br />
                  Testnet stage 1 CEX listing
                  <br />
                  Tier 1{/* <a href="#">View More</a> */}
                </p>
              </div>
            </Fade>

            <Fade bottom duration={duration}>
              <div className="box oct">
                <h3>Nov</h3>
                <p>
                  Precog 1 deployment Liquidity
                  <br />
                  Incentive program Sentient v1
                  <br />
                  Private beta test Sentient v1 public
                  <br />
                  Beta test Publication code audit
                  <br />
                  Sentient PR program Governance announcement
                </p>
              </div>
            </Fade>

            <Fade bottom duration={duration}>
              <div className="box nov">
                <h3>Dec</h3>
                <p>
                  Sentient alpha launch Sentient
                  <br /> Liquidity program CEX listing tier 1
                  <br />
                  (2) Bitcoin integration Sentient
                  <br />
                  Cerebral public demo v0.1 Cerebral
                  <br />
                  Closed beta testing Token
                  <br />
                  Partnerships for initial LPs
                  <br />
                  Derivative production
                </p>
              </div>
            </Fade>
          </div>

          {/* <div className="relationships">
          <div className="company">
            <img alt="" src={Logo1} />
          </div>
          <div className="company">
            <img alt="" src={Logo2} />
          </div>
          <div className="company">
            <img alt="" src={Logo3} />
          </div>
          <div className="company">
            <img alt="" src={Logo4} />
          </div>
          <div className="company">
            <img alt="" src={Logo5} />
          </div>
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProjectRoadmap;
